import { doc, setDoc } from 'firebase/firestore';
import { IReportOption } from '../../../providers/reports/reportOptions';
import { userAsPromise } from '../../../providers/userProvider';

/**
 * @description updates the metrics that the user wants
 * @param metric
 * @returns Promise
 */
export const updateSelectedReport = async (
  report: IReportOption
): Promise<void> => {
  const user = await userAsPromise();
  return setDoc(
    doc(user.services.firestore, `userProfiles/${user.id}/settings/report`),
    { report },
    { merge: true }
  );
};
